import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import PreguntasFioriCreate from "./PreguntasFioriCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";

function ListadoPreguntasFiori() {
  const { user } = useContext(AuthContext);
  const URL_PREGUNTAS_FIORI = process.env.REACT_APP_URL_PREGUNTAS_FIORI;

  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [preguntasFiori, setPreguntasFiori] = useState([]);
  const [modal, setModal] = useState(false);
  const [pregunta, setPregunta] = useState("");

  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_PREGUNTAS_FIORI, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPreguntasFiori = response.data;
        setPreguntasFiori(allPreguntasFiori);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editPreguntasFiori(event) {
    event.preventDefault();
    const URL_PREGUNTAS_FIORI_EDIT = `${process.env.REACT_APP_URL_PREGUNTAS_FIORI}/${idEdit}`;
    axios
      .patch(
        URL_PREGUNTAS_FIORI_EDIT,
        {
          pregunta,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Pregunta Fiori',
            detalle: pregunta,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, pregunta) {
        setPregunta(pregunta);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menu_logs ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">Preguntas</h3>
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Pregunta</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {preguntasFiori
                          .sort((a, b) => (a.casa > b.casa ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.pregunta}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.pregunta)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>

                                    <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={process.env.REACT_APP_URL_PREGUNTAS_FIORI}
                                    />                               
                                   
                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <PreguntasFioriCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Pregunta</ModalHeader>
        <ModalBody>
        <Label for="exampleEmail" className="mr-sm-2">
              Pregunta
            </Label>
            <Input
              type="text"
              placeholder="Pregunta"
              value={pregunta}
              required
              onChange={(e) => {
                setPregunta(e.target.value);
              }}
            />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editPreguntasFiori}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoPreguntasFiori;
